import React from "react";

import Layout from '@components/layout';
import PartnersTemplate from "@components/partnersPage/partnersTemplate";

const IndexPage = ({ pageContext }) => (
  <Layout locale={pageContext.locale}>
    <PartnersTemplate pageContext={pageContext} />
  </Layout>
);

export default IndexPage;
